<template>
  <div v-if=" step === 1">
    <HomeLazyImage style="width: 69%;height: auto;" :src="backgroundImageLogin" alt="ورود به پنل"/>
    <PhoneForm @success="goStep2" :phone="phone"/>
  </div>
  <div v-else-if=" step === 2">
    <HomeLazyImage style="width: 69%;height: auto;" :src="backgroundImageRegister" alt="ورود به پنل"/>
    <SmsLoginForm :phone="phone" @back="step = 1"/>
  </div>
</template>

<script setup>
  import { BASE_URL } from '@/config';
  import { ref,watch,onMounted } from 'vue'
  import HomeLazyImage from '@/components/tooles/lazy/HomeLazyImage.vue';
  import PhoneForm from '@/components/user/PhoneLogin/PhoneForm.vue'
  import SmsLoginForm from '@/components/user/PhoneLogin/SmsLoginForm.vue'
  const step=ref(1) 
  const phone=ref('')
  const backgroundImageLogin = ref(BASE_URL+'/assets/images/un.png')
  const backgroundImageRegister = ref(BASE_URL+'/assets/images/reset.png')
  onMounted(() => {
    const savedStep = sessionStorage.getItem('login_step')
    const savedPhone = sessionStorage.getItem('phone')
    if (savedStep) step.value = parseInt(savedStep)
    if (savedPhone) {phone.value = savedPhone }else{ step.value =1}
  })
  watch(step, val => sessionStorage.setItem('login_step', val))
  watch(phone, val => sessionStorage.setItem('phone', val))
  const goStep2=(val)=>{
    if(val){
      phone.value=val
      step.value=2
    }else{
      step.value=1
    }
  }
</script>
<style scoped>
  div{
    background: #fff;
    border-radius: 10px;
    text-align: center;
    width: 50%;
    padding: 20px;
    box-shadow: 0 0 10px grey;
    position: fixed;
    top: 10%;
    left: 25%;
    box-sizing: border-box;
    right: 25%;
  }
  @media screen and (max-width:600px){
      div{
        right: 15%;
        width: 70%;
        left: 15%;
      }
  }
</style>